var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHtml = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  height: 2500,
  width: 2183,
  viewBox: "0 0 124 141.532"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.383 126.894 0 0l124 .255-10.979 126.639-50.553 14.638z",
  fill: "#e34f26"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M62.468 129.277V12.085l51.064.17-9.106 104.851z",
  fill: "#ef652a"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m99.49 41.362 1.446-15.49H22.383l4.34 47.49h54.213L78.81 93.617l-17.362 4.68-17.617-5.106-.936-12.085H27.319l2.128 24.681 32 8.936 32.255-8.936 4.34-48.17H41.107L39.49 41.362z",
  fill: "#fff"
})));
export { SvgHtml as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/html.svg";